var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllAppIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44950",
    "data-name": "Group 44950",
    transform: "translate(67 -396)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63937",
    "data-name": "Rectangle 63937",
    width: 25,
    height: 25,
    transform: "translate(-67 396)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44941",
    "data-name": "Group 44941",
    transform: "translate(-72.076 397.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44567",
    "data-name": "Group 44567",
    transform: "translate(6.076 1.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89173",
    "data-name": "Path 89173",
    d: "M10.826,7.735A2.826,2.826,0,1,1,8,4.908,2.827,2.827,0,0,1,10.826,7.735Z",
    transform: "translate(-2.665 -0.189)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89174",
    "data-name": "Path 89174",
    d: "M6.718,16.475c-.1-.008.637-.013.534-.013h-2.4A4.017,4.017,0,0,0,1,20.622v.894H5.779",
    transform: "translate(-1 -5.418)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89175",
    "data-name": "Path 89175",
    d: "M29.74,23.329V21.835A6.707,6.707,0,0,0,23.3,14.89H18.366a6.707,6.707,0,0,0-6.44,6.945v1.493",
    transform: "translate(-6.74 -4.521)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89176",
    "data-name": "Path 89176",
    d: "M26.381,5.719A4.719,4.719,0,1,1,21.662,1,4.72,4.72,0,0,1,26.381,5.719Z",
    transform: "translate(-7.149 -1)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAppIco);
export default __webpack_public_path__ + "static/media/all-app-ico.9fa7c04e9c83f717874020d0cea389e9.svg";
export { ForwardRef as ReactComponent };